import type { AxiosError, AxiosResponse } from "axios";
import type { ApiRequestError, ErrorModel, RequestErrorModel } from "models/error/Error";
import { clearCookiesLogout } from "persistence/access";
import { redirectToIdpLogout } from "utils/idp";

export interface CustomErrorInterface {
  status: number;
  message: string;
}

export class CustomError extends Error {
  status: number;

  type: string;

  constructor({ message, status, type }: ErrorModel) {
    super(message);
    this.status = status;
    this.type = type;
  }
}

export function handlingResponse<T>(successStatus = [200], errorMessage = "Error", type = "") {
  return function axiosResponse(response: AxiosResponse): T {
    if (!successStatus.includes(response.status)) {
      throw new CustomError({ message: errorMessage, status: response.status, type });
    }
    return response.data as T;
  };
}

export const logError = (
  error: AxiosError<ApiRequestError>,
  useLogoutHandler = true,
): RequestErrorModel => {
  const { data, status } = error.response || {};

  // TODO: add aplication Insight
  if (useLogoutHandler && status === 401) {
    clearCookiesLogout();
    redirectToIdpLogout(window.location.pathname);
  }

  return {
    errCode: data?.extra?.errCode,
    message: data?.message || "",
    status: status || 500,
    type: data?.type || "",
  };
};
